import React from 'react';
import { DefaultButton } from '../Button/Default';
import { PrimaryButton } from '../Button/Primary';
import { Spinner, SpinnerSize } from '../Spinner';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CancelFooter = _ref => {
  let {
    cancelButton,
    saveButton
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    tokens: {
      childrenGap: 5
    },
    children: [/*#__PURE__*/_jsx(DefaultButton, {
      "data-id": cancelButton.dataId,
      onClick: cancelButton.onClick,
      disabled: cancelButton.isDisabled,
      children: "Cancel"
    }), /*#__PURE__*/_jsxs(PrimaryButton, {
      "data-id": saveButton.dataId,
      onClick: saveButton.onClick,
      disabled: saveButton.isDisabled,
      children: [saveButton.isLoading && /*#__PURE__*/_jsx(Spinner, {
        size: SpinnerSize.small,
        styles: {
          root: {
            marginRight: 8
          }
        }
      }), "Save"]
    })]
  });
};